import MwcVueHelperMixin from 'mwc-vue-component-helper';
import componentUI from './component-ui';
import component from './component';

export default {
    MwcVueHelperMixin,
    componentUI,
    component
};
